import React from 'react';
import { Helmet } from 'react-helmet-async';

const MetaTags = ({ 
  title = 'xdimension | Your AI Partner in Daily Life', 
  description = 'xdimension brings Ainous, advanced AI assistants in elegant robot hardware, to enhance your daily experiences and productivity.',
  image = 'https://xdimension.ai/og-image.jpg',
  url = 'https://xdimension.ai',
  article = false,
  publishedTime = '',
  modifiedTime = '',
  tags = []
}) => {
  const siteTitle = 'xdimension';
  const fullTitle = title === siteTitle ? title : `${title} | ${siteTitle}`;
  
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      
      {/* Open Graph Tags */}
      <meta property="og:site_name" content={siteTitle} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content={article ? 'article' : 'website'} />
      
      {/* Additional article meta tags */}
      {article && publishedTime && <meta property="article:published_time" content={publishedTime} />}
      {article && modifiedTime && <meta property="article:modified_time" content={modifiedTime} />}
      {article && tags.length > 0 && tags.map((tag, index) => (
        <meta property="article:tag" content={tag} key={index} />
      ))}
      
      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={url} />
    </Helmet>
  );
};

export default MetaTags;
